import FileSystemObjectType from '@/enums/FileSystemObjectType';

export const TestFileSystem = {
	id: 1,
	name: 'Hauptverzeichnis',
	root: true,
	type: FileSystemObjectType.Directory,
	children: [
		{
			id: 2,
			name: 'Test 1',
			root: false,
			type: FileSystemObjectType.Directory,
			children: [
				{
					id: 3,
					name: 'Sub 1',
					root: false,
					type: FileSystemObjectType.Directory,
				}
			],
			files: [
				{
					id: 2,
					name: 'Sub 2',
					root: false,
					size: 123789,
					type: FileSystemObjectType.File,
					mimeType: 'application/pdf'
				}
			]
		}
	],
	files: [
		{
			id: 1,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},
		{
			id: 2,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 3,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 4,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 5,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 6,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 7,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 8,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 9,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 10,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 11,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 12,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 13,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 14,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 15,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 16,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 17,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 18,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 19,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 20,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 21,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		},{
			id: 22,
			name: 'Test 2',
			root: false,
			type: FileSystemObjectType.File,
			mimeType: 'application/pdf'
		}
	]
};